const actions = {
    refresh: 'REFRESH',
    setIndex: 'SET_INDEX',
    setElement: 'SET_ELEMENT',
    decrementIndex: 'DECREMENT_INDEX',
    incrementIndex: 'INCREMENT_INDEX',
    toggleVisibility: 'TOGGLE_VISIBILITY',
};
const isRefreshAction = (action) => action.type === actions.refresh;
const isSetIndexAction = (action) => action.type === actions.setIndex;
const isSetElementAction = (action) => action.type === actions.setElement;
const isDecrementIndexAction = (action) => action.type === actions.decrementIndex;
const isIncrementIndexAction = (action) => action.type === actions.incrementIndex;
const isToggleAction = (action) => action.type === actions.toggleVisibility;
const reducer = (state, action) => {
    if (isRefreshAction(action)) {
        const { children, value } = action.payload;
        const selectedElement = getElementByValue(children, value);
        return {
            ...state,
            total: children.length,
            selectedElement,
            index: children.findIndex((element) => element === selectedElement),
        };
    }
    if (isSetIndexAction(action)) {
        return {
            ...state,
            index: action.payload.index,
        };
    }
    if (isSetElementAction(action)) {
        return {
            ...state,
            selectedElement: action.payload.element,
            index: action.payload.index,
        };
    }
    if (isDecrementIndexAction(action)) {
        const prevIndex = state.index;
        return {
            ...state,
            index: prevIndex < state.total - 1 ? prevIndex + 1 : prevIndex,
        };
    }
    if (isIncrementIndexAction(action)) {
        const prevIndex = state.index;
        return {
            ...state,
            index: prevIndex > 0 ? prevIndex - 1 : prevIndex,
        };
    }
    if (isToggleAction(action)) {
        return {
            ...state,
            isOpen: action.payload.isOpen,
        };
    }
    return state;
};
const getElementByValue = (elementArray, value) => {
    const defaultSelection = elementArray[0];
    if (typeof value === 'undefined') {
        return defaultSelection;
    }
    const selectedElement = elementArray.find((child) => {
        return child.props.value === value;
    });
    return selectedElement ? selectedElement : defaultSelection;
};
const initialiseReducer = ({ initialSelected, elementArray, isOpen, }) => {
    const initialElement = getElementByValue(elementArray, initialSelected);
    return {
        total: elementArray.length,
        selectedElement: initialElement,
        index: elementArray.indexOf(initialElement),
        isOpen,
    };
};

export { actions, initialiseReducer, reducer };
//# sourceMappingURL=reducer.js.map
